/* Chez Josh — collection.js : filtres Search & Discovery (auto-submit), tiroir filtres mobile, ajout rapide. */
(function () {
  var form = document.querySelector('[data-filter-form]');
  var section = document.querySelector('.collection');

  if (form) {
    form.addEventListener('change', function (e) {
      if (e.target.matches('[data-filter-input], [data-sort-select]')) form.submit();
    });
    form.addEventListener('submit', function () { document.body.classList.remove('no-scroll'); });
  }

  if (section) {
    document.querySelectorAll('[data-filter-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var open = section.classList.toggle('is-filtering');
        document.body.classList.toggle('no-scroll', open);
      });
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    var id = parseInt(btn.getAttribute('data-variant-id'), 10);
    if (!id || btn.disabled) return;
    var label = btn.querySelector('[data-label]') || btn;
    var original = label.textContent;
    btn.disabled = true;
    label.textContent = 'Ajout…';
    var reset = function () { btn.disabled = false; label.textContent = original; };
    if (window.ChezJosh && window.ChezJosh.addToCart) {
      window.ChezJosh.addToCart([{ id: id, quantity: 1 }], { openDrawer: true }).then(reset).catch(reset);
    } else {
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }) }).then(function () { window.location.href = '/cart'; }).catch(reset);
    }
  });
})();
